import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown
} from "reactstrap";
import DataTableView from "@components/views/datatable-view";
import DateRangePicker from "@components/fields/date-picker/range-picker";
import Filter from "../../common/filter";
import Flex from "@components/ui-components/flex";
import { FormProvider } from "react-hook-form";
import { LAST_30_DAYS_DATE } from "@src/utility/constants";
import LoadingButton from "@components/ui-components/loading-button";
import SideFilter from "@components/ui-components/side-filter";
import Upsert from "./upsert";
import useCompanies from "./use-companies";
import useDateHandler from "@src/utility/hooks/use-date-handler";
import useFilter from "../../common/use-filter";
import usePageChange from "@hooks/use-page-change";
import { useTranslation } from "react-i18next";
import useDataTableSort from "@src/utility/hooks/use-data-table-sort";

const CompaniesList = () => {
    const {
        loading,
        data,
        setQueryParams,
        getCompanies,
        handleSelectedRows,
        handleBulkActions,
        columns,
        handleModal,
        modalConfig,
        kpi,
        getKpi,
        handleSort: handleCompaniesSort
    } = useCompanies();

    const {
        sortField,
        sortDirection,
        handleSort: handleDataTableSort
    } = useDataTableSort();
    
    const handleSort = (column, direction) => {
        handleDataTableSort(column, direction);  
        handleCompaniesSort(column, direction);  
    };

    const { control, handleDateChange } = useDateHandler({
        onSubmit           : getCompanies,
        defaultValues      : LAST_30_DAYS_DATE,
        startWithEmptyRange: true
    });

    const {
        methods: filterMethods,
        onSubmit: filterSubmit,
        onReset: filterReset
    } = useFilter({ setQueryParams, kpi, getKpi });

    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });
    const { t } = useTranslation();

    return (
        <>
            <DataTableView
                moduleName="Companies"
                tableProps={{
                    enableSelect: true,
                    handleSelectedRows,
                    data        : data.companies,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination  : data.pagination,
                    fixedColumns: [
                        { index: 0, width: 48 },
                        { index: 1, width: 300 }
                    ],
                    sortField,
                    sortDirection,
                    handleSort
                }}
                loading={loading}
                actionItems={
                    <Flex align="center">
                        <UncontrolledDropdown>
                            <DropdownToggle
                                className="btn pe-1"
                                caret
                                color="primary">
                                {t("Actions")}
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem
                                    onClick={() => handleBulkActions("delete")}>
                                    {t("Delete Bulk Company")}
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        <DateRangePicker
                            control={control}
                            customOnChange={handleDateChange}
                            maxDate={new Date()}
                            id="date"
                            isClearable
                            name="date"/>
                        <LoadingButton
                            color="primary"
                            subject="companies"
                            action="create"
                            icon="plus"
                            text="Add Company"
                            onClick={() => handleModal()}/>
                        <SideFilter
                            title="Filters"
                            onSubmit={() => filterSubmit()}
                            onReset={() => filterReset()}>
                            <FormProvider {...filterMethods}>
                                <Filter showStagesFilter={true} kpis={kpi} />
                            </FormProvider>
                        </SideFilter>
                    </Flex>
                }/>
            <Upsert
                getCompanies={getCompanies}
                handleModal={handleModal}
                modalConfig={modalConfig}/>
        </>
    );
};

export default CompaniesList;